import * as React from "react";
import { Box, CPText, Container } from "../../base";
import "./CPGuestLandingLayoutStyles.scss";
import { Outlet } from "react-router-dom";
import AppNavBar from "../CPAppNavBar/CPAppNavBar";
import useAppStore from "../../../state/useAppState";
import { consumeSessionExpiredToastFlag } from "shared/helpers";

import logo from "../../../../assets/evans-bi-logo4-white.png";

const CPGuestLandingLayout: React.FC = () => {
  const setToastMsg = useAppStore((app) => app.setToastMsg);

  React.useEffect(() => {
    if (consumeSessionExpiredToastFlag()) {
      setToastMsg("Session expired, please login again", "error");
    }
  }, [setToastMsg]);

  return (
    <Container className="guest-content">
      <AppNavBar />

      <div className="overlay"></div>
      <div className="content">
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: 0,
            padding: "5rem",
          }}
        >
          {/* <CPText
          textStyle="h3"
          color="white"
          font={"montserrat"}
          transform={"uppercase"}
          align="center"
        >
          Business Intelligence HUB
        </CPText> */}
          <div>
            <Outlet />
          </div>
        </div>
      </div>
    </Container>
  );
};

export default CPGuestLandingLayout;
